<div
  (cdkDropListDropped)="drop($event)"
  cdkDropList
  cdkDropListOrientation="horizontal"
  class="header"
>

  <ng-container *ngFor="let cell of row;">

    <div
      *ngIf="cell.type == 'checkbox'"
      [attr.data-field]="cell.dataField"
      [style.width.px]="cell.width"
      cdkDrag
      cdkDragDisabled
      class="{{cell.dataField}}_cell_header"
    >
    <span>
      <div style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
        <label class="container">
          <input
            (click)="selectAllRows($event)"
            [checked]="allChecked"
            type="checkbox"
          >
          <span class="checkmark"></span>
        </label>
      </div>
    </span>
    </div>

    <iv-live-header-cell
      cdkDrag
      cdkDragDisabled
      cdkDropList
      cdkDropListOrientation="horizontal"
      class="header-cell {{cell.dataField}}_cell_header"
      *ngIf="cell.type !== 'checkbox'"
      (cdkDropListDropped)="drop($event)"
      [attr.data-field]="cell.dataField"
      [class.ascending]="cell.sortDirection === 'asc'"
      [class.descending]="cell.sortDirection === 'desc'"
      [class.sortable]="cell.sortable"
      [class.with-tip]="cell.description"
      [style.width.px]="cell.width"
      [value]="cell"
    ></iv-live-header-cell>
  </ng-container>

</div>
